module.exports = __webpack_public_path__ + "assets/img/right-title-open-1b142b58.png";